import { render, staticRenderFns } from "./AdditionalGeneralObservations.vue?vue&type=template&id=590bcc3e&scoped=true"
import script from "./AdditionalGeneralObservations.vue?vue&type=script&lang=js"
export * from "./AdditionalGeneralObservations.vue?vue&type=script&lang=js"
import style0 from "./AdditionalGeneralObservations.vue?vue&type=style&index=0&id=590bcc3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590bcc3e",
  null
  
)

export default component.exports